import { PrinterSearchIcon } from './PrinterSearchIcon';

/**
 * author: Michael Irigoyen
 * id 18383BEA-BF9A-43AD-87BB-F47CEC92F9C3
 * name printer-search
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-search.svg
 * tags
 * - Printer 
 */
export const PrinterMagnifyIcon = PrinterSearchIcon;
export default PrinterMagnifyIcon